export const promoConfig = {
  promoCode: "REVIVE40",
  discountPercent: 40, // 30% off
  startDate: "2023-12-07T00:00:00Z", // Promo start (expired)
  endDate: "2023-12-10T23:59:59Z", // Promo end (expired)
  message:
    "Get 40% OFF your first month until December 10th at midnight with code REVIVE40! Only 200 discounted spots available—act now!",
};
